import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import './FavoriteButton.css';

const FavoriteButton = ({ itemType, itemId, size = 24 }) => {
  const { user, token } = useAuth();
  const [isFavorite, setIsFavorite] = useState(false);
  const [loading, setLoading] = useState(false);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (user) {
      checkFavorite();
    }
  }, [user, itemId]);

  const checkFavorite = async () => {
    if (!user) return;

    try {
      const response = await fetch(`${BACKEND_URL}/api/favorites/${user.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const favorites = await response.json();
        const exists = favorites.some(
          fav => fav.item_type === itemType && fav.item_id === itemId
        );
        setIsFavorite(exists);
      }
    } catch (error) {
      console.error('Error checking favorite:', error);
    }
  };

  const toggleFavorite = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!user) {
      alert('Bitte melde dich an, um Favoriten zu speichern');
      return;
    }

    setLoading(true);

    try {
      if (isFavorite) {
        // Remove favorite
        const response = await fetch(`${BACKEND_URL}/api/favorites/${user.id}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const favorites = await response.json();
          const favorite = favorites.find(
            fav => fav.item_type === itemType && fav.item_id === itemId
          );

          if (favorite) {
            await fetch(`${BACKEND_URL}/api/favorites/${favorite.id}`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${token}`
              }
            });
          }
        }

        setIsFavorite(false);
      } else {
        // Add favorite
        await fetch(`${BACKEND_URL}/api/favorites`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            user_id: user.id,
            item_type: itemType,
            item_id: itemId
          })
        });

        setIsFavorite(true);
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
      alert('Fehler beim Speichern des Favoriten');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className={`favorite-button ${isFavorite ? 'active' : ''} ${loading ? 'loading' : ''}`}
      onClick={toggleFavorite}
      disabled={loading}
      title={isFavorite ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen'}
    >
      <Heart
        size={size}
        fill={isFavorite ? 'currentColor' : 'none'}
        className="favorite-icon"
      />
    </button>
  );
};

export default FavoriteButton;
